// extracted by mini-css-extract-plugin
export default {"wrapper":"cardEmployeeTooltip_wrapper__uyx-B"};